import { Grid, Typography } from "@mui/material";
// import Participantes from '../images/icone_participantes.png';
// import Mapa from '../images/icone_mapa.png'
import WatchOutlinedIcon from '@mui/icons-material/WatchOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
// import Calendario from '../images/icone_calendario.png'

export default function NumerosEvento() {
    return (
        <Grid sx={{ backgroundColor: '#f5f5f5', height: '45vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: { xl: 'row', lg: 'row', xs: 'column' } }}>
            <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '3%', marginBottom: '5vh' }}>
                <PeopleOutlineIcon sx={{ fontSize: { xl: 80, lg: 70, xs: 80 } }} />
                <Typography sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: { xl: '40px', lg: '25px', xs: '20px' }, color: '#545454' }} >+11 mil</Typography>
                <Typography textAlign="center" sx={{ color: '#737373', fontSize: { xl: '25px', lg: '18px', xs: '12px' } }} >
                    participantes na
                    última edição
                </Typography>
            </Grid>
            <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '3%', marginBottom: '5vh' }}>
                <MapOutlinedIcon sx={{ fontSize: { xl: 80, lg: 70, xs: 80 } }} />
                <Typography sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: { xl: '40px', lg: '25px', xs: '20px' }, color: '#545454' }} >8000m²</Typography>
                <Typography textAlign="center" sx={{ color: '#737373', fontSize: { xl: '25px', lg: '18px', xs: '12px' } }} >
                    de espaço de
                    exposição e evento
                </Typography>
            </Grid>
            <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '3%', marginBottom: '5vh' }}>
                <WatchOutlinedIcon sx={{ fontSize: { xl: 80, lg: 70, xs: 80 } }} />
                <Typography sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: { xl: '40px', lg: '25px', xs: '20px' }, color: '#545454' }} >62 horas</Typography>
                <Typography textAlign="center" sx={{ color: '#737373', fontSize: { xl: '25px', lg: '18px', xs: '12px' } }} >
                    de programação
                    principal e arenas
                </Typography>
            </Grid>
            <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '5vh' }}>
                <CalendarMonthOutlinedIcon sx={{ fontSize: { xl: 80, lg: 70, xs: 80 } }} />
                <Typography sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: { xl: '40px', lg: '25px', xs: '20px' }, color: '#545454' }} >25 edições</Typography>
                <Typography textAlign="center" sx={{ color: '#737373', fontSize: { xl: '25px', lg: '18px', xs: '12px' } }} >
                    do maior evento
                    municipalista do mundo
                </Typography>
            </Grid>
        </Grid>
    );
}
